import { Component, OnInit } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../../input/input.component';
import { FiltreService } from 'src/app/shared/filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'bis-date-input-keypad',
  templateUrl: './date-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class DateInputKeypadComponent extends InputComponent implements OnInit {

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  ngOnInit() {
    super.ngOnInit();
    // Ajout de FormControl servant à l’affichage de la valeur
    if (! this.formAffichage) {
      (this.currentControl.parent as UntypedFormGroup).setControl(this.labelAffichage, new UntypedFormControl(this.currentControl.value));
    }
    // Mise en place de la cohérence entre nos deux formControls
    // Comme toujours avec les subscriptions, ne pas oublier de fermer les ressources
    // Cela est fait automatiquement par la classe mère via subTab
    // TODO vérifier que les filtres marchent encore avec les emitEvent à false
    this.subTab.push(
      this.formAffichage.valueChanges.subscribe((value) => {
        const nouvelleDate = this.texteVersDate(value);
        this.currentControl.patchValue(nouvelleDate);
        this.formAffichage.patchValue(this.dateVersTexte(nouvelleDate), {emitEvent: false});
      })
    );
    this.subTab.push(
      this.currentControl.valueChanges.subscribe((value) => {
         this.formAffichage.patchValue(this.dateVersTexte(value), {emitEvent: false});
      })
    );
    // On force la mise à jour des valeurs
    this.currentControl.updateValueAndValidity();
  }

   /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
   get formAffichage (): UntypedFormControl {
    return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
  }

  /** Label à affecter au FormControl servant à l’affichage */
  get labelAffichage (): string {
    return this.label + '_affichage';
  }

  /** Formate une date format vers jj/mm/aaaa */
  protected dateVersTexte (valeur: string): string {
    const expressionReguliereNumerique =
        // tslint:disable-next-line: max-line-length
        new RegExp('^([0-2][0-9][0-9][0-9]-[0-1][0-9]-[0-3][0-9])$');

    return (valeur !== null && valeur.length === 10 && expressionReguliereNumerique.test(valeur))
      && moment(valeur, 'YYYY-MM-DD').isValid() ? moment(valeur).format('DD/MM/YYYY') : valeur;
  }

  /** Transforme jj/mm/aaaa affiche en format date pour api */
  protected texteVersDate (valeur: string): string {
    const expressionReguliereNumerique =
        // tslint:disable-next-line: max-line-length
        new RegExp('^([0-3][0-9]/[0-1][0-9]/[0-2][0-9][0-9][0-9])$');

     const expressionReguliereNumerique2 =
        // tslint:disable-next-line: max-line-length
        new RegExp('^([0-3][0-9][0-1][0-9][0-2][0-9][0-9][0-9])$');

    if (expressionReguliereNumerique2.test(valeur) && moment(valeur, 'DDMMYYYY').isValid()) {
        return moment(valeur, 'DDMMYYYY').format('YYYY-MM-DD');
    } else if (expressionReguliereNumerique.test(valeur) && moment(valeur, 'DD/MM/YYYY').isValid()) {
      return moment(valeur, 'DD/MM/YYYY').format('YYYY-MM-DD');
    } else {
      return valeur;
    }
  }

  /**
   * Les champs de type date ne permette pas d’avoir accès à la donnée en cours de saisie.
   * La variable apparaît vide alors que l’utilisateur a pu commencer à taper quelque chose qui ne sera alors pas sauvegardé.
   * Le champ passe au vert que lorsque la variable n’est plus à vide, même si il n’y a pas de contrôle « require »
   */
  champValide() {
    // Le champ est valide s’il n’y a pas d’erreur croisée
    return this.currentControl.valid && this.currentControl.value !== null
      && this.currentControl.value !== '' && !this.aErreurCroiseeActive();
  }

  /** Besoin de réécrire cette fonction pour travailler sur le champ visible à l’écran */
  champTouche() {
    return this.formAffichage.touched;
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }

}

